import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { calculateRem } from '@vds-core/utilities';
import { Fonts } from '@vds-core/typography';
import { AccessibilityTokens } from '@vds-tokens/accessibility';
import { TypographyTokens } from '@vds-tokens/typography';
var StyledLabel = /*#__PURE__*/styled.label.withConfig({
  displayName: "StyledLabel",
  componentId: "VDS__sc-1bjel3a-0"
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: inline-flex;\n  border-radius: 1rem;\n  height: ", ";\n  width: ", ";\n  ", "\n"])), calculateRem(24), calculateRem(52), function (_ref) {
  var disabled = _ref.disabled,
      surface = _ref.surface,
      keyboardFocused = _ref.keyboardFocused;
  return !disabled && keyboardFocused && "\n    &:not(:hover) {\n      outline: none;\n      &::before {\n        border: ".concat(calculateRem(AccessibilityTokens.focusring.borderwidth.value), " ").concat(AccessibilityTokens.focusring.borderstyle.value, " ").concat(surface === 'dark' ? AccessibilityTokens.color.focusring.ondark.value : AccessibilityTokens.color.focusring.onlight.value, ";\n        box-sizing: border-box;\n        border-radius: 1rem;\n        content: '';\n        height: calc(100% + ").concat(calculateRem(6), ");\n        left: 50%;\n        position: absolute;\n        top: 50%;\n        transform: translate(-50%, -50%);\n        width: calc(100% + ").concat(calculateRem(6), ");\n      }\n    }\n    ");
});
var ToggleSwitchSlider = /*#__PURE__*/styled.span.withConfig({
  displayName: "ToggleSwitchSlider",
  componentId: "VDS__sc-1bjel3a-1"
})(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  border-radius: 1rem;\n  border: ", " solid transparent;\n  box-sizing: border-box;\n  position: relative;\n  display: inline-flex;\n  cursor: ", ";\n  background-color: ", ";\n  color: ", ";\n  height: ", ";\n  transition: background-color 100ms;\n  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\n  width: ", ";\n  &::before {\n    background-color: ", ";\n    border-radius: 50%;\n    bottom: 0;\n    content: '';\n    height: ", ";\n    left: 0;\n    margin-bottom: auto;\n    margin-top: auto;\n    padding-left: 0;\n    position: absolute;\n    top: 0;\n    transition: left 100ms;\n    width: ", ";\n    z-index: 1;\n  }\n\n  &:active,\n  &:focus {\n    outline: none;\n  }\n\n  ", ";\n\n  ", ";\n\n  ", ";\n"])), calculateRem(2), function (_ref2) {
  var disabled = _ref2.disabled;
  return disabled ? null : 'pointer';
}, function (_ref3) {
  var calculateBackgroundColor = _ref3.calculateBackgroundColor,
      disabled = _ref3.disabled,
      on = _ref3.on,
      surface = _ref3.surface,
      textPosition = _ref3.textPosition;
  return calculateBackgroundColor(disabled, on, surface);
}, function (_ref4) {
  var calculateTextColor = _ref4.calculateTextColor,
      disabled = _ref4.disabled,
      surface = _ref4.surface,
      textPosition = _ref4.textPosition;
  return calculateTextColor(disabled, surface, textPosition);
}, calculateRem(24), calculateRem(52), function (_ref5) {
  var calculateButtonColor = _ref5.calculateButtonColor,
      disabled = _ref5.disabled,
      surface = _ref5.surface;
  return calculateButtonColor(disabled, surface);
}, calculateRem(20), calculateRem(20), function (_ref6) {
  var showText = _ref6.showText,
      textPosition = _ref6.textPosition;
  return showText && textPosition === 'center' && "\n    &::after {\n      content: 'Off';\n      font-size: ".concat(calculateRem(TypographyTokens.fontsize.body[12].value), ";\n      line-height: ").concat(calculateRem(TypographyTokens.lineheight.body[16].value), ";\n      font-weight: ").concat(TypographyTokens.fontweight.bold.value, ";\n      font-family: ").concat(Fonts.VerizonNHGeTX, ";\n      position: absolute;\n      right: ").concat(calculateRem(4), ";\n      top: ").concat(calculateRem(3), ";\n      z-index: 0;\n    }\n\n  ");
}, function (_ref7) {
  var on = _ref7.on,
      disabled = _ref7.disabled;
  return on && "\n    transition: background-color 100ms;\n    transition-timing-function: cubic-bezier(0.4, 0.0, 0.2, 1.0);\n    &::before {\n      content: '';\n      left: ".concat(calculateRem(28), " !important; \n      transition: left 100ms; \n    }\n  ");
}, function (_ref8) {
  var showText = _ref8.showText,
      on = _ref8.on,
      calculateTextColor = _ref8.calculateTextColor,
      disabled = _ref8.disabled,
      surface = _ref8.surface,
      textPosition = _ref8.textPosition;
  return on && showText && textPosition === 'center' && "\n    &::after {\n      color: ".concat(calculateTextColor(disabled, surface), ";\n      content: 'On';\n      right: ").concat(calculateRem(24), ";\n      top: ").concat(calculateRem(3), ";\n      z-index: 0;\n    }\n  ");
});
var ToggleInput = /*#__PURE__*/styled.input.withConfig({
  displayName: "ToggleInput",
  componentId: "VDS__sc-1bjel3a-2"
})(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  opacity: 0;\n  margin: 0;\n  width: 2rem;\n  height: 1rem;\n  position: absolute;\n  top: 0;\n  &:hover {\n    cursor: pointer;\n  }\n"])));
var propTypes = {
  on: PropTypes.bool,
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
  onKeyPress: PropTypes.func,
  onChange: PropTypes.func,
  name: PropTypes.string,

  /**
   * @ignore
   * Function that determines text color of Toggle
   */
  calculateTextColor: PropTypes.func,

  /**
   * @ignore
   * Function that determines background color of Toggle
   */
  calculateBackgroundColor: PropTypes.func,

  /**
   * @ignore
   * Function that determines background color of Toggle button
   */
  calculateButtonColor: PropTypes.func,

  /**
   * @ignore
   */
  tabIndex: PropTypes.number
};
var defaultProps = {
  on: false,
  disabled: false,
  onClick: function onClick() {},
  onKeyPress: function onKeyPress() {},
  onChange: function onChange() {},
  name: null
};
/**
 * @ignore
 */

var ToggleSwitch = /*#__PURE__*/function (_Component) {
  _inherits(ToggleSwitch, _Component);

  var _super = _createSuper(ToggleSwitch);

  function ToggleSwitch() {
    var _this;

    _classCallCheck(this, ToggleSwitch);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      keyboardFocused: false
    });

    _defineProperty(_assertThisInitialized(_this), "_onFocus", function () {
      _this.setState({
        keyboardFocused: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "_onBlur", function () {
      _this.setState({
        keyboardFocused: false
      });
    });

    return _this;
  }

  _createClass(ToggleSwitch, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          onProp = _this$props.on,
          disabled = _this$props.disabled,
          onKeyDown = _this$props.onKeyDown,
          handleSwitchClick = _this$props.handleSwitchClick,
          onChange = _this$props.onChange,
          tabIndex = _this$props.tabIndex,
          name = _this$props.name,
          value = _this$props.value,
          calculateTextColor = _this$props.calculateTextColor,
          calculateBackgroundColor = _this$props.calculateBackgroundColor,
          calculateButtonColor = _this$props.calculateButtonColor,
          analyticsTrack = _this$props.analyticsTrack,
          track = _this$props.track,
          trackIgnore = _this$props.trackIgnore,
          clickStream = _this$props.clickStream,
          surface = _this$props.surface,
          inputId = _this$props.inputId,
          focusId = _this$props.focusId,
          textPosition = _this$props.textPosition,
          showText = _this$props.showText,
          ariaLabel = _this$props.ariaLabel;
      var on = onProp;
      return /*#__PURE__*/React.createElement(StyledLabel, {
        id: focusId,
        disabled: disabled,
        surface: surface,
        htmlFor: inputId ? inputId : name ? name : 'toggle',
        keyboardFocused: this.state.keyboardFocused
      }, /*#__PURE__*/React.createElement(ToggleInput, {
        "data-testid": "test-toggle",
        "aria-label": ariaLabel ? ariaLabel : name,
        type: "checkbox",
        disabled: disabled,
        checked: on,
        name: name,
        value: value,
        id: inputId ? inputId : name ? name : 'toggle',
        tabIndex: tabIndex,
        "data-analyticstrack": analyticsTrack,
        "data-track": track,
        "data-track-ignore": trackIgnore,
        "data-clickstream": clickStream,
        onFocus: this._onFocus,
        onBlur: this._onBlur,
        onChange: onChange,
        onKeyDown: onKeyDown,
        onClick: function onClick(e) {
          return handleSwitchClick(e);
        }
      }), /*#__PURE__*/React.createElement(ToggleSwitchSlider, {
        tabIndex: -1,
        "aria-hidden": true,
        surface: surface,
        disabled: disabled,
        on: +on,
        calculateTextColor: calculateTextColor,
        calculateBackgroundColor: calculateBackgroundColor,
        calculateButtonColor: calculateButtonColor,
        textPosition: textPosition,
        showText: showText
      }));
    }
  }]);

  return ToggleSwitch;
}(Component);

ToggleSwitch.propTypes = propTypes;
ToggleSwitch.defaultProps = defaultProps;
export default ToggleSwitch;